/**
 * Scorecard API endpoints.
 * Each function returns the factory-created methods bound to the request helpers.
 *
 * @param {{ makeRequest: Function, buildRequest: Function, baseUrl: string }} dependencies
 */
export default function ScorecardApi({ makeRequest, buildRequest, baseUrl = '' }) {

    function getCurrentScorecard(employeeEmail) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/api/KPIData/current`, {
                params: employeeEmail ? { employeeEmail } : undefined,
            }));
        });
    }

    function refreshKpiData(employeeEmail) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/api/KPIData/current/refreshKpiData`, null, {
                params: employeeEmail ? { employeeEmail } : undefined,
            }));
        });
    }

    function triggerDataRefresh() {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/api/RefreshTrigger/landData`));
        });
    }

    function getScorecardHistory(employeeEmail) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/api/KPIData/history`, {
                params: employeeEmail ? { employeeEmail } : undefined,
            }));
        });
    }

    function getScorecardById(kpiDataId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/api/KPIData/${kpiDataId}`));
        });
    }

    function upsertScorecard(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/api/KPIData`, payload));
        });
    }

    function getKpiGoals(kpiDataId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/api/KPIGoal`, {
                params: { kpiDataId },
            }));
        });
    }

    function upsertKpiGoal(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/api/KPIGoal`, payload));
        });
    }

    function deleteKpiGoal(id) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`${baseUrl}/api/KPIGoal/${id}`));
        });
    }

    function upsertKpiGoalReflection(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/api/KPIGoal/reflection`, payload));
        });
    }

    function getSubordinates(employeeEmail) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/api/KPIData/subordinates`, {
                params: employeeEmail ? { employeeEmail } : undefined,
            }));
        });
    }

    function submitFeedback(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/api/KPIDataFeedback`, payload));
        });
    }

    function deleteFeedback(id) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`${baseUrl}/api/KPIDataFeedback/${id}`));
        });
    }

    function getEmployees() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/api/KPIData/employees`));
        });
    }

    function getSignalRConnection() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/api/SignalR/negotiate`));
        });
    }

    return {
        getCurrentScorecard,
        refreshKpiData,
        triggerDataRefresh,
        getScorecardHistory,
        getScorecardById,
        upsertScorecard,
        getKpiGoals,
        upsertKpiGoal,
        deleteKpiGoal,
        upsertKpiGoalReflection,
        getSubordinates,
        submitFeedback,
        deleteFeedback,
        getEmployees,
        getSignalRConnection,
    };
}
